module.exports = __webpack_public_path__ + "img/cashft-explorer-card.49d75b7.webp";